import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  FormLabel,
  FormHelperText,
} from "@mui/material";
import { useFormikContext } from "formik";
import { path } from "ramda";

const getPath = (name) => name.split(".");

const RadioInput = ({ name, label, options, sx, ...props }) => {
  const { values, handleBlur, handleChange, errors, touched } =
    useFormikContext();
  const namePath = getPath(name);
  const error = path(namePath, touched) && path(namePath, errors);
  const value = path(namePath, values);
  const labelId = `${name}-label`;
  return (
    <FormControl style={{ width: "100%" }} error={!!error}>
      <FormHelperText>{error}</FormHelperText>
      <FormLabel id={labelId}>{label}</FormLabel>
      <RadioGroup
        aria-labelledby={labelId}
        name={name}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        {...props}
      >
        {options.map(({ text, value }) => (
          <FormControlLabel
            value={value}
            control={<Radio color="primary" sx={sx ?? {}}/>}
            label={text}
            key={value}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
export default RadioInput;

RadioInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.string,
    })
  ).isRequired,
};
